define([
    "float-labels.min",
    "Magento_Ui/js/lib/view/utils/dom-observer",
    "jquery"
], function (Floatlabel, domObserver, $) {
    'use strict';

    // Array of id or class names for the forms which should not be float labeled
    const floatLabelExclusions = [
        "search_mobile_form",
        "search_mini_form",
        "bfx-cc-form",
        "shipping-zip-form",
        "discount-coupon-form",
        "klaviyo-form",
        "yotpo-review-form"
    ];
    const floatlabelOptions = {};
    const selectors = ['input', 'textarea', 'select'];

    /*
     * Checks if nodes classes or id is in the exclusions list
     */
    function shouldApplyFloatLabel (exclusions, node) {
        const identifiers = node.classList + node.id;

        return !exclusions.some(function (value, index, array) {
            const regex = RegExp(value);
            return regex.test(identifiers);
        });
    }

    selectors.forEach((selector) => {
        domObserver.get(selector, function (node) {
            const parentForm = $(node).closest("form");

            // safety check
            if (
                parentForm.length === 0 ||
                !shouldApplyFloatLabel(floatLabelExclusions, parentForm.get(0))
            ) {
                return;
            }

            let floatForm = new Floatlabel(parentForm.get(0), floatlabelOptions);

            // if the fl form has already been built, trigger a rebuild with the new input
            if (floatForm && parentForm.hasClass("fl-form")) {
                floatForm.rebuild();
            }
        });
    });
});
